'use strict';

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _interactionListMediaItem = require('lemon-db/dist/options/interactionListMediaItem.json');

var _interactionListMediaItem2 = _interopRequireDefault(_interactionListMediaItem);

var _extendChild = require('../../util/extendChild');

var _extendChild2 = _interopRequireDefault(_extendChild);

var _explicitChildren = require('../../util/explicitChildren');

var _explicitChildren2 = _interopRequireDefault(_explicitChildren);

var _formatLink = require('../../util/formatLink');

var _Media = require('../../molecules/Media');

var _Media2 = _interopRequireDefault(_Media);

var _Icon = require('../../molecules/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _TextDraft = require('../../molecules/TextDraft');

var _TextDraft2 = _interopRequireDefault(_TextDraft);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSpring = require('react-spring');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Animation


var options = exports.options = _interactionListMediaItem2['default'];

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      Card = _ref.Card;

  var MediaAnswer = function (_React$Component) {
    _inherits(MediaAnswer, _React$Component);

    function MediaAnswer() {
      _classCallCheck(this, MediaAnswer);

      return _possibleConstructorReturn(this, (MediaAnswer.__proto__ || Object.getPrototypeOf(MediaAnswer)).apply(this, arguments));
    }

    _createClass(MediaAnswer, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            children = _props.children,
            clickHandler = _props.clickHandler,
            link = _props.link,
            isResponsive = _props.isResponsive,
            animationStyles = _props.animationStyles,
            bouncy = _props.bouncy;
        var answerClickHandler = link ? null : clickHandler;
        var mediaAnswerTheme = Object.assign({}, theme);
        mediaAnswerTheme.answer = (0, _classnames2['default'])(mediaAnswerTheme.answer, _defineProperty({}, mediaAnswerTheme.bouncy, bouncy));
        mediaAnswerTheme.card += ' ' + mediaAnswerTheme.answer;
        mediaAnswerTheme.card += ' ' + mediaAnswerTheme.minor;

        var top = _react2['default'].createElement('div', null, '\xA0');

        var bottom = _react2['default'].createElement('div', null, '\xA0');

        if (children && children.length) {
          top = (0, _extendChild2['default'])(children[0], _Media2['default'].themeShape, theme, {
            preventDesktopBehaviour: true,
            box: _extends({}, (0, _get2['default'])(children[0], 'props.box'), {
              theme: {
                box: theme.childBox,
                boxWrapper: theme.childBox
              }
            })
          });
          bottom = (0, _extendChild2['default'])(children[1], _TextDraft2['default'].themeShape, theme, {
            isResponsive: isResponsive,
            preventDesktopBehaviour: true,
            box: _extends({}, (0, _get2['default'])(children[1], 'props.box'), {
              theme: {
                box: theme.childBox,
                boxWrapper: theme.childBox
              }
            })
          });
        }

        var answer = _react2['default'].createElement(Card, {
          clickHandler: answerClickHandler,
          theme: mediaAnswerTheme
        }, top, bottom);

        if (animationStyles) {
          answer = _react2['default'].createElement(_reactSpring.animated.div, {
            style: animationStyles
          }, answer);
        }

        if (link) {
          return _react2['default'].createElement('a', {
            href: this.formattedLink,
            rel: 'noopener noreferrer',
            className: theme.linkWrapper
          }, answer);
        }

        return answer;
      }
    }, {
      key: 'formattedLink',
      get: function get() {
        var link = this.props.link;
        return (0, _formatLink.formatLink)(link);
      }
    }]);

    return MediaAnswer;
  }(_react2['default'].Component);

  MediaAnswer.themeShape = _extends({}, _Media2['default'].themeShape, _Icon2['default'].themeShape, _TextDraft2['default'].themeShape, {
    answer: _propTypes2['default'].string,
    linkWrapper: _propTypes2['default'].string
  });
  MediaAnswer.displayName = identifier;
  MediaAnswer.propTypes = {
    children: (0, _explicitChildren2['default'])([['Icon', 'Media'], ['TextDraft']]),
    theme: _propTypes2['default'].shape(MediaAnswer.themeShape),
    link: _propTypes2['default'].string,
    clickHandler: _propTypes2['default'].func,
    isResponsive: _propTypes2['default'].bool,
    bouncy: _propTypes2['default'].bool,
    animationStyles: _propTypes2['default'].object
  };
  return MediaAnswer;
};

exports['default'] = factory;